import React, { useContext, useState } from 'react';
import { faqData } from '../assets/dummyData/faq';
import { NewsLetterContentFaq } from '../assets/dummyData/NewsLetterData';
import Faq from '../components/Faq/Faq';
import NewLetter from '../components/NewLetter/NewLetter';
import { Context } from '../context/Products';
import ModalEmailSuccess from '../components/ModalEmailSuccess/ModalEmailSuccess';
import Helmet from "../components/Helmet"
import { seo } from '../assets/dummyData/seo';

const FaqPage = () => {
  const [{ lang }] = useContext(Context);
  const [shoeModalEmail, setShoeModalEmail] = useState(false);

  const modalEmail = () => {
    setShoeModalEmail(true);
    const body = document.body;
    body.classList.add("modal-open");
    setTimeout(() => {
        setShoeModalEmail(false);
    }, 500);
  }

  return (
    <div id="page-faq" className="page">
        <Helmet
          title={seo[lang].faq.title}
          metaDesc={seo[lang].faq.description}
          lang={lang}
        />
        <Faq data={faqData[lang]} title={faqData?.title[lang]} />
        <NewLetter hiddeImg data={NewsLetterContentFaq[lang]} openModal={modalEmail} lang={lang} />
        <ModalEmailSuccess open={shoeModalEmail} />
    </div>
  )
}

export default FaqPage;
